// 現在の言語を取得するフック
import type { Language } from '../types/translations';

export const useCurrentLanguage = (): Language => {
  // window.wakoFlowLocale から現在の言語を取得
  const locale = window.wakoFlowLocale;
  
  // URLベースでの言語判定（フォールバック）
  const pathname = window.location.pathname;
  const urlBasedLanguage = pathname.startsWith('/en/') ? 'en' : 'ja';
  
  let result: Language;
  
  // 日本以外は英語の判定ロジック（useTranslationsと同じ）
  if (locale === 'ja') {
    result = 'ja';
  } else if (locale) {
    // 日本語以外のlocaleが設定されている場合は英語
    result = 'en';
  } else {
    // localeが未設定の場合はURLから判定
    result = urlBasedLanguage;
  }
  return result;
}; 